import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';
import { Shell } from './components/Shell';
import { OfflineOverlay } from './lib/ConnectionProvider';
import { AccountPage } from './pages/AccountPage';
import { EventOperationsPage } from './pages/EventOperationsPage';
import { EventPage } from './pages/EventPage';
import { EventsPage } from './pages/EventsPage';
import { LoginPage } from './pages/LoginPage';
import { UsersPage } from './pages/UsersPage';

export function App() {
  const { status } = useAuth();

  // Finché non sappiamo chi c'è dall'altra parte non si mostra né l'app né la
  // schermata di accesso: un lampo di "accedi" a chi è già dentro è peggio di
  // mezzo secondo di attesa.
  if (status === 'checking') return <BootScreen />;

  if (status === 'anonymous') {
    return (
      <>
        <LoginPage />
        <OfflineOverlay />
      </>
    );
  }

  return (
    <>
      <Shell>
        <Routes>
          <Route path="/" element={<EventsPage />} />
          <Route path="/eventi/:eventId" element={<EventPage />} />
          <Route path="/eventi/:eventId/operazioni" element={<EventOperationsPage />} />
          <Route path="/utenti" element={<AdminOnly><UsersPage /></AdminOnly>} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>
      <OfflineOverlay />
    </>
  );
}

function AdminOnly({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user?.role !== 'admin') return <Navigate to="/" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
}

function BootScreen() {
  return (
    <div className="login">
      <div className="login__box">
        <div className="login__brand">
          <Logo size={64} />
          <p className="muted">Un momento…</p>
        </div>
      </div>
    </div>
  );
}

/** Il marchio: lo stesso anello e la stessa spunta dell'icona dell'app. */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label="PietroChip"
      style={{ flex: 'none' }}
    >
      <circle cx="256" cy="256" r="154" fill="none" stroke="currentColor" strokeWidth="45" />
      {/* Il magenta di EvoData. Va in `style` e non in `stroke="…"`: gli
          attributi di presentazione non accettano `var()`. */}
      <path
        d="M 160 265 L 226 331 L 362 176"
        fill="none"
        style={{ stroke: 'var(--brand)' }}
        strokeWidth="52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
